import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import MinusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MinusIconPath";
import PlusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PlusIconPath";
import { useTranslation } from "@coworker/locales";
import styles from "./zoom-control.module.css";

interface ZoomControlProps {
  currentZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  minZoom?: number;
  maxZoom?: number;
}

const commonButtonProps = {
  type: "image-overlay" as const,
  size: "small" as const,
  iconOnly: true as const,
};

export const ZoomControl = ({
  currentZoom,
  onZoomIn,
  onZoomOut,
  minZoom = 100,
  maxZoom = 500,
}: ZoomControlProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles["zoomControlBar"]}>
      <FixaButton
        {...commonButtonProps}
        aria-label={t("zoomOutAriaLabelString")}
        data-testid="zoomControlMinus"
        ssrIcon={MinusIconPath}
        onClick={onZoomOut}
        disabled={currentZoom <= minZoom}
      />
      <div
        className={styles["zoomControlPercentageBox"]}
        tabIndex={0}
        data-testid="zoomPercentageBox"
        aria-label={t("zoomLevelAriaLabelString", { zoomLevel: currentZoom })}
      >
        {currentZoom}%
      </div>
      <FixaButton
        {...commonButtonProps}
        aria-label={t("zoomInAriaLabelString")}
        data-testid="zoomControlPlus"
        ssrIcon={PlusIconPath}
        onClick={onZoomIn}
        disabled={currentZoom >= maxZoom}
      />
    </div>
  );
};
